import { HandlersPresenceActivityResponseFromJSON } from '~/api/models/HandlersPresenceActivityResponse';
import type { ActivityResponse } from '~/marketing/presenceContract';

import { isJsonContentType } from '../utils/upstreamHttpResponse';

function base(): string {
  return import.meta.env.VITE_PRESENCE_API_BASE_URL?.replace(/\/+$/, '') || '';
}

const init: RequestInit = {
  credentials: 'include',
  headers: { Accept: 'application/json' },
};

export function presenceApiEnabled(): boolean {
  return base().length > 0;
}

export async function fetchActivity(city: string): Promise<ActivityResponse | null> {
  if (!base()) return null;
  const u = new URL(`${base()}/api/presence/activity`);
  u.searchParams.set('city', city);
  const r = await fetch(u, init);
  if (!r.ok || !isJsonContentType(r.headers.get('content-type'))) return null;
  return HandlersPresenceActivityResponseFromJSON(await r.json());
}
